/**
 * FIX C: pure delay math for the /rooms poll's bounded exponential backoff.
 *
 * Extracted as a side-effect-free helper so the backoff curve is unit-testable
 * without mocking LiveKit / the Svelte component. The poll loop in Class.svelte
 * owns the scheduling (single-owner generation guard); this only computes the
 * next delay:
 *
 *  - on a SUCCESSFUL poll, reset to the base cadence (5s);
 *  - on a FAILED poll, double the current delay, capped at `max` (30s).
 */

/** Next delay after a successful poll: always the base cadence. */
export function backoffOnSuccess(base: number): number {
  return base;
}

/** Next delay after a failed poll: double current, capped at `max`. */
export function backoffOnFailure(current: number, max: number): number {
  return Math.min(current * 2, max);
}
